import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ViewController,
  Platform,
  ToastController,
  AlertController,
  LoadingController
} from "ionic-angular";
import { Store } from "@ngrx/store";
import { WalletFetchAction } from "../../app/app.actions";

import { AppState } from "../../app/app.reducer";

import { Idol, Token, Wallet, User } from "../../app/app.models";
import { ConfigService } from "../../services/config.service";
import * as firebase from "firebase";
import { IdolsStorageService } from "../../services/idols.storage.service";
import { FannelPage } from "../fannel/fannel";
import {
  AngularFireDatabase,
  FirebaseListObservable
} from "angularfire2/database";

import { AppUtilities } from "../../app/app.utilities";
import { FcmService } from "../../services/fcm.service";
import { AuthService } from "../../services/auth.service";
import { FirebaseService } from "../../services/firebase.service";
import { tap } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { CATEGORIES } from "../../app/app.models";
import { GoogleAnalytics } from "@ionic-native/google-analytics";
import { WalletService } from "../../services/wallet.service";
import { WalletPage } from "../../pages/wallet/wallet";
import { MarketplacePage } from "../marketplace/marketplace";
import { HelpPage } from "../help/help";
import { FannelsListPage } from "../fannels-list/fannels-list";

@Component({
  selector: "page-idols-list",
  templateUrl: "idols-list.html"
})
export class IdolsListPage {
  public wallet$: Wallet;
  public tokensAll$: Token[] = [];
  public user$: User;
  public marketplacePage = MarketplacePage;
  public fannelsListPage = FannelsListPage;
  listCategorize: any[];
  listCategoraizeTemp: any[];
  idolsSC: any[];
  public refresh;
  items: FirebaseListObservable<any>;
  fannels: any = {};
  numIdols: number;
  haveFannels = { have: false };

  ios: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public store: Store<AppState>,
    public afDatabase: AngularFireDatabase,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private translateService: TranslateService,
    private fcm: FcmService,
    private platform: Platform,
    private toastCtrl: ToastController,
    private authService: AuthService,
    private ga: GoogleAnalytics,
    public alertCtrl: AlertController,
    private walletService: WalletService,
    private firebaseService: FirebaseService,
    private utilities: AppUtilities,
    public loadingCtrl: LoadingController
  ) {
    this.user$ = this.authService.getUser();
    this.notifications();
    this.fetchIdolsList();

    this.store.select("wallet").subscribe((wallet: Wallet) => {
      if (wallet && wallet.address) {
        this.wallet$ = wallet;
        // Get tokens if first call
        if (this.tokensAll$ && !this.tokensAll$.length) {
        }
      }
    });
    this.store.dispatch(new WalletFetchAction(this.user$));
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad IdolsListPage");
    this.ga
      .trackView("HomePage")
      .then(() => {})
      .catch(e => console.log(e));

    if (this.configService.getShowSeedsMessage() === "yes") {
      var alert_seeds_message = this.translateService.instant(
        "home.alert_seeds_message"
      );
      var alert_seeds_accept = this.translateService.instant(
        "home.alert_seeds_accept"
      );
      var idioma = this.configService.getIdiom();

      let alert;

      alert = this.alertCtrl.create({
        enableBackdropDismiss: false,
        subTitle: alert_seeds_message,
        buttons: [
          {
            text: alert_seeds_accept,
            role: "cancel",
            handler: () => {
              console.log("Aceptar");
              this.configService.setShowSeedsMessage("no");
            }
          }
        ]
      });
      alert.present();
    }
  }

  ionViewWillEnter() {
    console.log("ionViewWillEnter IdolsListPage");
    this.walletService.getShowAlert().then(val => {
      if (val) {
        console.log("get show Alert");
        this.openAlertNewSeedsGenerated();
      }
    });

    this.fannelsOpen(this.haveFannels);
  }

  reciveautograph() {
    this.navCtrl.push(WalletPage, { segment: "address" });
  }

  notifications() {
    // Get a FCM token
    this.fcm.getToken(this.user$);
    this.fcm
      .listenToNotifications()
      .pipe(
        tap((msg: any) => {
          let messageText: string;
          if (this.platform.is("android")) {
            messageText = msg.body;
          }

          if (this.platform.is("ios")) {
            messageText = msg.aps.alert.body;
          }

          const toast = this.toastCtrl.create({
            message: messageText,
            duration: 3000,
            position: "top"
          });
          toast.present();
        })
      )
      .subscribe();
  }

  goHelp() {
    this.navCtrl.push(HelpPage);
  }

  doRefresh($event) {
    this.refresh = $event;
    this.fetchIdolsList();
    $event.complete();
  }

  fannelsOpen(haveFannels) {
    console.log("opne fanel");

    //production
    var db = firebase.database().ref("/prod_fannels");
    //test
    //var db = firebase.database().ref('/fannels');
    db.on("value", function(snapshot) {
      console.log("have fannels var ", haveFannels);
      haveFannels.have = false;
      var fannels = snapshot.val();
      var keys = Object.keys(fannels);
      console.log("fannels ", fannels, " keys ", keys);
      for (var x = 0; x < keys.length; x++) {
        var item = fannels[keys[x]];
        var itemKeys = Object.keys(item);
        console.log(
          "Fannels item ",
          item,
          " item finish ",
          item[itemKeys[0]].finish
        );
        for (var z = 0; z < itemKeys.length; z++) {
          if (item[itemKeys[z]].finish == false) {
            if (item[itemKeys[z]].periode > Date.now()) {
              haveFannels.have = true;
              break;
            }
          }
        }
        if (haveFannels.have == true) {
          break;
        }
      }
    });
  }

  fetchIdolsList() {
    var listIdols: any[];
    this.listCategorize = [];
    this.listCategoraizeTemp = [];
    var LOADING_IDOLS = this.translateService.instant("LOADING_IDOLS");
    this.utilities.loading(LOADING_IDOLS);
    //Prodcution
    firebase
      .database()
      .ref("/prod_idols/")
      .once("value")
      .then((snapshot: any) => {
        var itemsUID = snapshot.val();
        var items = [];
        console.log("lista de idolos ", itemsUID, " length ", itemsUID.length);
        firebase
          .database()
          .ref("/prod_fannels")
          .once("value")
          .then((snapshot: any) => {
            this.fannels = snapshot.val();
            var uids = Object.keys(itemsUID);
            uids.forEach(uid => {
              items.push(itemsUID[uid]);
            });

            listIdols = this.createIdolsList(items);
            CATEGORIES.forEach(category => {
              var idolsListCategorize = this.categorizeIdols(
                category,
                listIdols
              );
              if (idolsListCategorize.length > 0) {
                this.listCategorize.push({ category, idolsListCategorize });
                this.listCategoraizeTemp.push({
                  category,
                  idolsListCategorize
                });
              }
            });

            console.log("listCategorize ", this.listCategorize);
            this.utilities.loadingDismiss();
          });
      })
      .catch(err => {
        this.utilities.loadingDismiss();
      });
  }

  createIdolsList(items) {
    var listIdols = [];

    items.forEach(item => {
      var person = item;
      person.name = person.name.charAt(0).toUpperCase() + person.name.slice(1);

      listIdols.push({
        displayName: person.name,
        name: person.name,
        address: person.address,
        mainImageUrl: person.mainImageUrl,
        category: person.category,
        photoUrl: person.photoUrl,
        description: person.description,
        featuredImageUrl: person.featuredImageUrl,
        facebookUrl: person.facebookUrl,
        twitterUrl: person.twitterUrl,
        instagramUrl: person.instagramUrl,
        uid: person.uid,
        star: person.star
      });
    });
    return listIdols;
  }

  categorizeIdols(category, listAllIdols) {
    var listIdolscategorized;

    listIdolscategorized = listAllIdols.filter(idol => {
      return idol.category == category;
    });

    listIdolscategorized = this.orederCategorizedIdolsList(
      listIdolscategorized
    );
    return listIdolscategorized;
  }

  orederCategorizedIdolsList(listIdolscategorized) {
    var listWithoutAccents = this.getNameWithoutAccents(listIdolscategorized);
    listIdolscategorized = this.orederList(listWithoutAccents);
    return listIdolscategorized;
  }

  orederList(list) {
    var idols: any[] = [];
    list.forEach(idol => {
      if (this.fannels && this.fannels[idol.address]) {
        console.log(
          "Fannel Open ? " + this.isFannelOpen(this.fannels[idol.address])
        );
        idol.fannel = this.isFannelOpen(this.fannels[idol.address]);
      }
      idols.push(idol);
    });

    if (idols && typeof idols.sort === "function") {
      // Sort all idols alphabetically
      idols.sort((a: Idol, b: Idol) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;

        return 0;
      });
    }
    list = idols;
    return list;
  }

  isFannelOpen(fannel) {
    var open = false;
    for (var i in fannel) {
      if (fannel[i].periode > Date.now()) {
        console.log("Fannel-" + i + " periode " + fannel[i].periode);
        open = true;
      }
    }
    return open;
  }

  goFannel(idol) {
    this.navCtrl.push(FannelPage, { idol: idol });
  }

  getNameWithoutAccents(list) {
    for (var x = 0; x < list.length; x++) {
      list[x].name = this.deleteAccents(list[x].name.toLowerCase());
    }
    return list;
  }

  deleteAccents(cadena) {
    var chars = {
      á: "a",
      é: "e",
      í: "i",
      ó: "o",
      ú: "u",
      à: "a",
      è: "e",
      ì: "i",
      ò: "o",
      ù: "u",
      ñ: "n",
      Á: "A",
      É: "E",
      Í: "I",
      Ó: "O",
      Ú: "U",
      À: "A",
      È: "E",
      Ì: "I",
      Ò: "O",
      Ù: "U",
      Ñ: "N"
    };
    var expr = /[áàéèíìóòúùñ]/gi;
    var res = cadena.replace(expr, function(e) {
      return chars[e];
    });
    return res;
  }

  getItems(ev: any) {
    const val = ev.target.value;

    var listCategorizeFilter = [];

    if (val && val.trim() != "") {
      this.listCategorize.forEach(list => {
        var category = list.category;
        var idolsListCategorize = [];
        idolsListCategorize = list.idolsListCategorize.filter(idol => {
          return idol["name"].toLowerCase().indexOf(val.toLowerCase()) > -1;
        });
        listCategorizeFilter.push({ category, idolsListCategorize });
      });
      this.listCategoraizeTemp = listCategorizeFilter.slice();
    } else {
      this.listCategoraizeTemp = this.listCategorize.slice();
    }
  }

  openAlertNewSeedsGenerated() {
    var ALERT_NEW_SEED_TITLE = this.translateService.instant(
      "ALERT_NEW_SEED_TITLE"
    );
    var ALERT_NEW_SEED_MESSAGE = this.translateService.instant(
      "ALERT_NEW_SEED_MESSAGE"
    );
    var ALERT_NEW_SEED_TENGO = this.translateService.instant(
      "ALERT_NEW_SEED_TENGO"
    );
    var ALERT_NEW_SEED_NUEVA_GUARDAR = this.translateService.instant(
      "ALERT_NEW_SEED_NUEVA_GUARDAR"
    );

    let alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title: ALERT_NEW_SEED_TITLE,
      message: ALERT_NEW_SEED_MESSAGE,
      buttons: [
        {
          text: this.translateService.instant("ALERT_INFO_SEED"),
          cssClass: "alert_btn_title",
          handler: () => {
            this.openAlertSeedsInfo();
          }
        },
        {
          text: ALERT_NEW_SEED_NUEVA_GUARDAR,
          handler: () => {
            this.walletService.setShowAlert(false);
            this.navCtrl.push(WalletPage, { segment: "seeds" });
            console.log("Ya tengo una semillay");
          }
        },
        {
          text: ALERT_NEW_SEED_TENGO,
          handler: () => {
            this.walletService.setShowAlert(false);
            this.setYourSeeds();
            console.log("Guardar está semilla de forma segura");
          }
        }
      ]
    });
    alert.present();
  }

  openAlertSeedsInfo() {
    const alert = this.alertCtrl.create({
      subTitle: this.translateService.instant("SEEDS_INFO"),
      buttons: [
        {
          text: "OK",
          handler: () => {
            this.openAlertNewSeedsGenerated();
          }
        }
      ]
    });
    alert.present();
  }

  setYourSeeds() {
    var IMPORT_SEED = this.translateService.instant("IMPORT_SEED");
    var WRITE_SEED = this.translateService.instant("WRITE_SEED");
    var GUARDAR = this.translateService.instant("GUARDAR");
    var CANCELAR = this.translateService.instant("CANCELAR");
    let alert = this.alertCtrl.create({
      title: IMPORT_SEED,
      inputs: [
        {
          name: "seed",
          placeholder: WRITE_SEED
        }
      ],
      buttons: [
        {
          text: CANCELAR,
          role: "cancel",
          handler: data => {
            console.log("Cancel clicked ", data);
          }
        },
        {
          text: GUARDAR,
          handler: data => {
            console.log("data setyourSeeds ", data);
            this.walletService.updateSeeds(data.seed).then(() => {
              this.firebaseService.updateUserAddresData(
                this.user$.uid,
                this.walletService.getAddress()
              );
              this.store.dispatch(new WalletFetchAction(this.user$));
              //this.update();
            });
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/idols-list/idols-list.ts